import type { Ref } from 'vue';
import { watch } from 'vue';

import { UnknownQueryFetchError } from '@modules/core/errors';

export default function waitQueryPromiseHelper<T, TError>(
  checkField: Ref<boolean>,
  data: Ref<T | undefined>,
  error: Ref<TError | undefined | null>,
  resolve: (data: T) => void,
  reject: <T>(error: T) => void,
  opposite = false,
): void {
  const handleQuery = (): void => {
    if (data.value) {
      resolve(data.value);
      return;
    }

    reject(error.value ?? new UnknownQueryFetchError());
  };

  if (opposite ? !checkField.value : checkField.value) {
    handleQuery();
    return;
  }

  const unwatchFetched = watch(checkField, (newValue) => {
    if (opposite ? !newValue : newValue) {
      handleQuery();
      unwatchFetched();
    }
  });
}
